import { AppBar, Button, Grid, makeStyles, Toolbar, Typography, useMediaQuery, useTheme, CircularProgress } from "@material-ui/core";
import { ArrowBackIos } from '@material-ui/icons';
import { useBranch, useStateRef, useUrlState } from '@zennya/web-component-library/src';
import clsx from 'clsx';
import useCustomModal from 'components/CustomConfirm';
import CustomConfirmDialog from 'components/CustomConfirm/CustomConfirmDialog';
import { LocationTypeSelectDialog } from 'pages/CustomerBooking/Confirm/LocationTypeSelectDialog';
import { adjustTransactionAsIdsState, adjustTransactionState, calculatedTransactionAmountState, clientState, hasEditedBookingItemsState, highlightActionState, isWaitingForPollState, modifiedBookingItemsState, promoState, requiresNewScheduleState, STEP_STATE_COMPLETE, STEP_STATE_SCHEDULE, STEP_STATE_SUMMARY, stepState } from 'pages/CustomerBooking/RecoilState';
import { ScheduleConfirmationDialog } from 'pages/CustomerBooking/ScheduleConfimation/ConfirmDialog';
import { DRAWER_WIDTH } from 'pages/CustomerBooking/Stepper/Sidebar';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { testLogEventWhitelabel, useUserState } from 'services/authentication.service';
import { cancelBooking, confirmBooking, createNewBooking } from 'services/booking.service';
import { HelvNeue } from 'themes/theme';
import { canCancel, canConfirm, canMessage, canProceed, canReschedule, canShowTransaction, isBookingConfirmed, isCancelled, isCompleted, isPayable, parseBookingStatus, requiresLocationConfirmation } from 'util/bookingStates';
import { filterNonNull, oxfordComma, personNameFormal } from 'util/format';
import { useRunOnce } from 'util/stateref';
import { useTrackEvent } from 'util/trackEvent';
import { BookingDetailCard } from './BookingDetailCard';
import { CancelBookingDialog } from './CancelBookingDialog';
import { Client } from "./Client";
import { PaymentSummary } from './PaymentSummary';
import { Transaction } from './Transaction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning, faXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-hot-toast';
import { calculatePayment } from 'services/payments.service';
import { toasterror } from "util/toasterror";


const useStyles = makeStyles((theme) => {
  return {
    shrinkableToolbar: {
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(2),
        flexDirection: 'column',
        alignItems: 'flex-start',
      }
    },
    root: {
      flexGrow: 1,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
      },
      padding: theme.spacing(3),

    },
    support: {
      marginBottom: theme.spacing(3)
    },
    paddedLeft: {

    },
    paddedRight: {

    },
    content: {
      '&>*': {
        marginTop: theme.spacing(2)
      }
    },
    top: {
      bottom: 'auto',
      top: 0,
      right: 'auto',
    },
    bottom: {
      top: 'auto',
      bottom: 0,
      right: 'auto',
    },
    fixed: {
      [theme.breakpoints.up('md')]: {
        left: DRAWER_WIDTH,
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
      },
    },
    appBar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-evenly',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      flexWrap: 'wrap',
      [theme.breakpoints.up('md')]: {
        flexWrap: 'nowrap',
        '& button+button': {
          marginLeft: theme.spacing(2),
        },
      },

    },
    title: {
      flexGrow: 1,
      fontFamily: HelvNeue,
    }
  }
})
const BookingDetail = ({ fromMap = false, booking, loading, onRefreshContent = () => { } }) => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const confirm = useCustomModal()

  const clientStatus = useRecoilValue(clientState)
  const setStepState = useSetRecoilState(stepState)

  const setHighlightActionState = useSetRecoilState(highlightActionState);
  const onHighlightAction = useRecoilValue(highlightActionState);
  const adjustTransactionAsIds = useRecoilValue(adjustTransactionAsIdsState)

  const modifiedBookingItems = useRecoilValue(modifiedBookingItemsState);

  const [calculatedAmount, setCalculatedAmount] = useRecoilState(calculatedTransactionAmountState);
  const [promo, setPromo] = useRecoilState(promoState);
  const highlightscrollref = useRef(null)
  const requiresNewSchedule = useRecoilValue(requiresNewScheduleState);
  const { user, getIdentity, getUser } = useUserState()
  const [userState, setUserState, userStateRef] = useStateRef();

  const [sessionID, setsessionID, sessionRef] = useStateRef();
  const [showCancel, setShowCancel] = useState(false);
  const [adjustTransaction, setAdjustTransaction] = useRecoilState(adjustTransactionState);
  const [isWaitingForPoll, setIsWaitingForPoll] = useRecoilState(isWaitingForPollState);

  const BRANCH_API_KEY = process.env.REACT_APP_BRANCH_API_KEY

  const { branchStatus, getBranchIdentity, deepLink, generateDeeplink } = useBranch({
    apiKey: BRANCH_API_KEY,
  })

  const trackEvent = useTrackEvent()
  useRunOnce(() => {
    testLogEventWhitelabel(booking?.id, medium, `[customer-${booking?.white_label_customer?.id || booking?.client?.id}: ${personNameFormal(booking?.white_label_customer || booking?.client)}] authenticated and viewed booking details`)
  }, sessionID, () => {
    return !!sessionRef.current
  })

  useEffect(() => {

    async function fetchUser() {
      const user = await getUser(booking?.id)
      setUserState(user)
      setsessionID(`${user?.user?.id || user?.client?.id} - ${booking?.id}`)
    }
    fetchUser()

  }, [booking?.id]);

  useEffect(() => {
    generateDeeplink()
    setStepState(STEP_STATE_SCHEDULE)
    // onRefreshContent()
  }, []);

  const [medium, setMedium] = useUrlState({
    queryKey: 'medium',
  });



  useEffect(() => {
    if (onHighlightAction) {
      highlightscrollref?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      setHighlightActionState(false)
    }
  }, [onHighlightAction, setHighlightActionState]);

  const goToProfile = useCallback(
    () => {
      trackEvent('Booking Details - See Provider Profile ', { link: `/bookings/${booking?.id}/providerProfile` + history.location.search })
      history.push(`/bookings/${booking?.id}/providerProfile` + history.location.search, { from: 'booking' })
    },
    [booking?.id, history],
  );
  const doRescheduleBooking = useCallback(
    async () => {
      confirm(props => (
        <CustomConfirmDialog {...props}
          description={<Typography>Are you sure you want to reschedule this booking?</Typography>}
          title='Change booking time'
          confirmationText='Okay'
          onConfirm={() => {
            trackEvent('Booking Details - Change Booking Time - Okay ', { dialog: 'doRescheduleBooking' })
            props.onClose()
            onRefreshContent()
            // trackEvent('Booking Details - Change Booking Time -> Reschedule', { dialog: 'doRescheduleBooking', link: `/bookings/${booking?.id}/reschedule` + history.location.search })
            history.push(`/bookings/${booking?.id}/reschedule` + history.location.search)
          }}
          onCancel={async () => {
            trackEvent('Booking Details - Change Booking Time - Cancel ', { dialog: 'doRescheduleBooking' })
            props.onClose()
          }}
        />
      ))
    },
    [booking?.id, confirm, history, onRefreshContent],
  );

  const doRebooking = useCallback(
    async () => {
      confirm(props => (
        <CustomConfirmDialog {...props}

          description={
            (
              <div className={classes.content}>
                <Typography>Are you sure you want to reschedule this booking?</Typography>
                {booking?.scheduled_status === 'MATCHED' && (
                  <Typography variant="body2" color="error">Note that the status of this booking will reset back to pending. Do you want to proceed?</Typography>
                )}
              </div>
            )}
          title='Change booking time'
          confirmationText='Okay'
          onConfirm={() => {
            trackEvent('Booking Details - Booking Recreation  - Okay ', { dialog: 'doRebooking' })
            props.onClose()
            onRefreshContent()
            // trackEvent('Navigate Booking Recreation -> Rebooking', { dialog: 'doRebooking', link: `/bookings/${booking?.id}/rebooking` + history.location.search })
            history.push(`/bookings/${booking?.id}/rebooking` + history.location.search)
          }}
          onCancel={async () => {
            trackEvent('Booking Details - Booking Recreation - Cancel ', { dialog: 'doRebooking' })
            props.onClose()
          }}
        />
      ))
    },
    [booking?.id, confirm, history, onRefreshContent],
  );

  const [calculatedTotalPayable, setCalculatedTotalPayable] = useRecoilState(calculatedTransactionAmountState);
  const performChangeContentBooking = useCallback(
    async (payload) => {
      try {
        const { bookingClientId, bookingParams, cancellable } = { ...payload }

        const results = await calculatePayment(booking?.client?.id, bookingParams)
        const calcPayable = results?.total

        if (calcPayable > 0) {
          trackEvent('Booking Details - -ChangedBooking Contents -> Payment', { dialog: 'performChangeContentBooking', link: `/bookings/${booking?.id}/payment` + history.location.search })
          history.push(`/bookings/${booking?.id}/payment` + history.location.search, {
            from: 'booking',
            bookingClientId,
            bookingParams,
            cancellable
          })
        } else {
          setIsWaitingForPoll(true)
          await cancelBooking(booking?.id)
          const newBooking = await createNewBooking(bookingClientId, bookingParams)
          trackEvent('Booking Details - ChangedBooking Contents -> Success', { dialog: 'performChangeContentBooking', link: `/bookings/${newBooking?.id}` + history.location.search })
          setAdjustTransaction(null)
          await confirmBooking(newBooking?.id)
          history.replace(`/bookings/${newBooking?.id}` + history.location.search)
        }
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
      }
    },
    [calculatedTotalPayable],
  );

  const doModifiedBookingRebook = useCallback(
    async (mString) => {
      confirm(props => {
        console.log('index.jsx (235) # mString', mString);
        return <CustomConfirmDialog {...props}
          title='Are you sure all booking details are correct?'
          description={
            (
              <div>
                <Typography paragraph>
                  Items in the booking have been updated from the original.  Please review the changes before confirming.
                </Typography>
                <Typography>
                  This action is irreversible.
                </Typography>
              </div>
            )
          }
          preHeader={<FontAwesomeIcon icon={faWarning} size="9x" color={theme.palette.warning.light} />}
          confirmationText='Okay'
          onConfirm={async () => {
            trackEvent('Booking Details - Accept booking -> Payment', { dialog: 'doAcceptBooking', link: `/bookings/${booking?.id}/payment` + history.location.search })
            const payload = {
              bookingClientId: booking?.client?.id,
              bookingParams: filterNonNull({
                date_scheduled: booking?.date_scheduled,
                media_files: booking?.media_file_ids,
                service_addon_order: booking?.service_addon_order,
                location_id: booking?.user_location?.id,
                lat: booking?.user_location?.latitude,
                lng: booking?.user_location?.longitude,
                type: booking?.type?.id,
                booking_notes: booking?.booking_notes,
                white_label_customer: booking?.white_label_customer?.id,
                wlp_id: booking?.white_label_partner?.id,
                old_service_request_id: booking?.id,
                zennya_booking_id_enabled: true,
                ...adjustTransactionAsIds,
                "code": promo?.code || booking?.promo?.code,
                "code_type": promo?.type || booking?.promo?.type,
              }),
              cancellable: true
            }
            await performChangeContentBooking(payload)
            props.onClose()
          }}
          onCancel={async () => {
            trackEvent('Booking Details - Accept booking - Cancel ', { dialog: 'doAcceptBooking' })
            props.onClose()
          }}
        />
      }
      )
    },
    [adjustTransactionAsIds, promo, booking?.id, booking?.requires_payment, confirm, history, onRefreshContent],
  );

  const doAcceptBooking = useCallback(
    async () => {
      confirm(props => (
        <CustomConfirmDialog {...props}
          title='Are you sure all booking details are correct?'
          confirmationText='Okay'
          onConfirm={async () => {
            props.onClose()
            onRefreshContent()
            if (isPayable(booking)) {
              trackEvent('Booking Details - Accept booking -> Payment', { dialog: 'doAcceptBooking', link: `/bookings/${booking?.id}/payment` + history.location.search })
              history.push(`/bookings/${booking?.id}/payment` + history.location.search, { from: 'booking' })
            } else {
              setIsWaitingForPoll(true)
              trackEvent('Booking Details - Accept booking - Okay ', { dialog: 'doAcceptBooking' })
              await confirmBooking(booking?.id)
            }
          }}
          onCancel={async () => {
            trackEvent('Booking Details - Accept booking - Cancel ', { dialog: 'doAcceptBooking' })
            props.onClose()
          }}
        />
      ))
    },
    [booking?.id, booking?.requires_payment, confirm, history, onRefreshContent],
  );

  const doShowCancellation = useCallback(
    () => {
      if (booking?.is_whitelabel) {
        confirm(props => (
          <CustomConfirmDialog {...props}
            description={
              <Typography>To book again, contact {booking?.white_label?.partner?.label} or download the app for more services.</Typography>
            }
            title='Your booking is now cancelled'
            confirmationText='Download App'
            onConfirm={() => {
              window.open(deepLink, '_blank')
              trackEvent('Booking Details - Booking cancelled - Download App', { dialog: 'doShowCancellationDialog' })
              props.onClose()
              onRefreshContent()
            }}
            noCancel
          />
        ))
      }
      else {
        confirm(props => (
          <CustomConfirmDialog {...props}
            description={
              <Typography>To create new appointment, click below</Typography>
            }
            title='Your booking is now cancelled'
            confirmationText='Create new Appointment'
            onConfirm={async () => {
              await props.onClose()
              await trackEvent('Booking Details - Booking cancelled - Book Again', { dialog: 'doShowCancellationDialog' })
              history.push(`/createbooking/servicepackages`)
              window.location.reload()
            }}
            noCancel
          />
        ))
      }
    },
    [confirm, deepLink, booking],
  );

  const doCancelBooking = useCallback(
    async () => {
      confirm(props => (
        <CustomConfirmDialog {...props}
          description={<Typography>Are you sure you want to cancel this booking?</Typography>}
          title='Are you sure you want to cancel your booking?'
          confirmationText='Yes, Cancel'
          cancellationText='Changed my mind'
          onConfirm={async () => {
            props.onClose()
            setIsWaitingForPoll(true)
            trackEvent('Booking Details - Cancel Confirmation - Yes ', { dialog: 'doShowCancelBooking' })
            await cancelBooking(booking?.id)
            doShowCancellation()
          }}
          onCancel={async () => {
            props.onClose()
            trackEvent('Booking Details - Cancel Confirmation - Changed my mind ', { dialog: 'doShowCancelBooking' })
          }}
        />
      ))
    },
    [booking?.id, booking?.requires_payment, confirm, history],
  );

  const nextProcess = useCallback(
    async () => {
      onRefreshContent()
    },
    [onRefreshContent]
  );

  const serviceStatus = useMemo(
    () => {
      const isComplete = isCompleted(booking)
      if (isComplete) {
        setStepState(STEP_STATE_COMPLETE)
      }
      if (booking.is_confirmed) {
        setStepState(STEP_STATE_SUMMARY)
      }
      return isComplete ? 'Service Complete' : 'Your Booking Request'
    },
    [booking, setStepState],
  );
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  const onTestResultClick = useCallback(
    () => {
      trackEvent('Booking Details - back to bookings - click')
      history.push(`/bookings/${booking?.id}/results` + history.location.search)
    },
    [booking?.id, history],
  );

  const backButton = useMemo(
    () => {
      if (booking?.is_whitelabel) {
        return <></>
      }
      return <Button size="small" variant="link" startIcon={<ArrowBackIos />} onClick={() => {
        trackEvent('Booking Details - Back - click', { link: `/bookings` + history.location.search })
        history.push(`/createbooking/bookings` + history.location.search)
        window.location.reload()
      }}>Bookings</Button>
    }, [booking]
  );
  const ApplicationBar = useMemo(() => {
    if (fromMap) {
      return <AppBar elevation={0} position="static" color="secondary" className={clsx(classes.top, classes.appBar)}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Your Booking - In Progress
          </Typography>
          <Button size="small" color="primary" onClick={() => {
            trackEvent('Booking Details - Map - click', { link: `/bookings/${booking?.id}/map` + history.location.search })
            history.replace(`/bookings/${booking?.id}/map` + history.location.search)
          }} variant="contained"
            startIcon={<ArrowBackIos />}> Map</Button>

        </Toolbar>
      </AppBar>
    } else {
      return <AppBar elevation={0} position="static" color="default" className={clsx(classes.top, classes.appBar)}>
        <Toolbar className={classes.shrinkableToolbar}>
          {backButton}
          <Typography variant="h6" className={classes.title}>
            {serviceStatus}
          </Typography>
          {(canCancel(booking) && !isMobile) &&
            <Button
              disabled={isWaitingForPoll}
              startIcon={isWaitingForPoll && <CircularProgress size={20} />}
              size="small" color="secondary" onClick={() => {
                trackEvent('Booking Details - Cancel Booking - click', {})
                // doCancelBooking()
                setShowCancel(true)
              }} variant="outlined">Cancel Booking</Button>
          }
          {(isCompleted(booking)) &&
            <Button size="small" color="primary" onClick={() => {
              onTestResultClick()
            }} variant="contained">Access Test Results</Button>
          }
        </Toolbar>
      </AppBar>
    }
  }, [booking, classes.appBar, classes.title, classes.top, doCancelBooking, fromMap, history, isMobile, onTestResultClick, serviceStatus, isWaitingForPoll]);

  const [parse, setParse] = useState();
  const [hasAllProfilesAssigned, setHasAllProfilesAssigned] = useState(false);
  const hasEditedBookingItems = useRecoilValue(hasEditedBookingItemsState);
  const parsedBookingStatus = useMemo(
    () => {
      return parseBookingStatus(booking)
    }, [booking]
  );

  const renderConfirmDialogs = useMemo(
    () => {
      if (requiresLocationConfirmation(booking) && requiresNewSchedule) {
        return <LocationTypeSelectDialog booking={booking} />
      }
      if (requiresLocationConfirmation(booking)) {
        return <LocationTypeSelectDialog booking={booking} />
      }
      if (requiresNewSchedule) {
        return <ScheduleConfirmationDialog
          asDialog
          booking={booking}
          confirmContext={confirm}
        />
      }

    }, [booking]
  );

  const renderToolbar = useMemo(
    () => {
      const buttonArray = []
      if (canReschedule(booking)) {
        buttonArray.push(
          <Button
            disabled={isWaitingForPoll}
            startIcon={isWaitingForPoll && <CircularProgress size={20} />}
            key={1} fullWidth color="primary" size="large" onClick={() => {
              trackEvent('Booking Details - Reschedule - click', {})
              doRescheduleBooking()
            }} variant="outlined">Reschedule</Button>
        )
      }
      if (parsedBookingStatus?.rebookable) {
        buttonArray.push(
          <Button
            disabled={isWaitingForPoll}
            startIcon={isWaitingForPoll && <CircularProgress size={20} />}
            key={2} fullWidth color="primary" size="large" onClick={() => {
              trackEvent('Booking Details - Rebook - click', {})
              doRebooking()
            }} variant="outlined">Reschedule</Button>
        )
      }

      if (canConfirm(booking)) {
        if (hasEditedBookingItems) {
          buttonArray.push(
            <Button
              disabled={isWaitingForPoll}
              startIcon={isWaitingForPoll && <CircularProgress size={20} />}
              fullWidth color="primary" size="large" onClick={() => {
                trackEvent('Booking Details - Confirm (has modified booking) - click', {})
                doModifiedBookingRebook(modifiedBookingItems) //NOTE: why does this only change value IN memo and not in callback
              }} variant="contained">Confirm</Button>
          )
        } else {
          buttonArray.push(
            <Button
              disabled={isWaitingForPoll}
              startIcon={isWaitingForPoll && <CircularProgress size={20} />}
              fullWidth color="primary" size="large" onClick={() => {
                trackEvent('Booking Details - Confirm - click', {})
                doAcceptBooking()
              }} variant="contained">Confirm</Button>
          )
        }
      }

      if (canProceed(booking)) {
        buttonArray.push(
          <Button
            disabled={isWaitingForPoll}
            startIcon={isWaitingForPoll && <CircularProgress size={20} />}
            key={4} color="primary" onClick={() => {
              trackEvent('Booking Details - Proceed - click', {})
              nextProcess()
            }} variant="contained">Proceed</Button>
        )
      }
      if (canCancel(booking) && isMobile) {
        buttonArray.push(
          <Button
            disabled={isWaitingForPoll}
            startIcon={isWaitingForPoll && <CircularProgress size={20} />}
            key={5} fullWidth color="secondary" onClick={() => {
              trackEvent('Booking Details - Cancel Booking - click', {})
              // doCancelBooking()
              setShowCancel(true)
            }} variant="outlined">Cancel Booking</Button>
        )
      }
      return buttonArray

    }, [isWaitingForPoll, booking, isMobile, hasEditedBookingItems, modifiedBookingItems]
  );

  return (
    <>
      {ApplicationBar}
      {renderConfirmDialogs}
      <CancelBookingDialog
        open={showCancel}
        onConfirm={async (reason) => {
          setShowCancel(false)
          setIsWaitingForPoll(true)
          trackEvent('Booking Details - Cancel Confirmation - Yes ', { dialog: 'doShowCancelBooking' })
          await cancelBooking(booking?.id, reason)
          doShowCancellation()
        }}
        onClose={async () => {
          trackEvent('Booking Details - Cancel Confirmation - Changed my mind ', { dialog: 'doShowCancelBooking' })
          // await confirmBooking(booking?.id)
          setShowCancel(false)
        }}
      />
      <Grid container className={classes.root} spacing={3}>
        <Grid item xs={12} md={6} >
          <BookingDetailCard
            loading={loading}
            booking={booking}
            enableMessaging={canMessage(booking, clientStatus)}
            goToProfile={() => goToProfile()}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {
            canShowTransaction(booking) ?
              <PaymentSummary booking={booking} transaction={booking?.transaction} />
              :
              <Transaction booking={booking} readOnly={isCancelled(booking) || isCompleted(booking) || isBookingConfirmed(booking)} />
          }
        </Grid>

        {!fromMap && (
          <Grid item xs={12} md={6} ref={highlightscrollref}>
            <Toolbar className={classes.toolbar} >
              {renderToolbar}
            </Toolbar>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export { BookingDetail };
